import { createContext } from "react";

export const popupContext = createContext()